import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-datepicker-header',
  templateUrl: './datepicker-header.component.html',
  styleUrls: ['./datepicker-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatIconModule],
})
export class DatepickerHeaderComponent<D> implements OnInit, OnDestroy {
  private calendar = inject<MatCalendar<D>>(MatCalendar);
  private dateAdapter = inject<DateAdapter<D>>(DateAdapter);
  private _dateFormats = inject<MatDateFormats>(MAT_DATE_FORMATS);

  private destroyed = new Subject<void>();

  constructor() {
    const calendar = this.calendar;
    const cdr = inject(ChangeDetectorRef);

    calendar.stateChanges.pipe(takeUntil(this.destroyed)).subscribe(() => cdr.markForCheck());
  }

  ngOnInit(): void {
    this.initializeLanguage();
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }

  get periodLabel() {
    return this.dateAdapter.format(this.calendar.activeDate, this._dateFormats.display.monthYearLabel);
  }

  previousClicked(mode: 'month' | 'year') {
    this.calendar.activeDate =
      mode === 'month'
        ? this.dateAdapter.addCalendarMonths(this.calendar.activeDate, -1)
        : this.dateAdapter.addCalendarYears(this.calendar.activeDate, -1);
  }

  nextClicked(mode: 'month' | 'year') {
    this.calendar.activeDate =
      mode === 'month'
        ? this.dateAdapter.addCalendarMonths(this.calendar.activeDate, 1)
        : this.dateAdapter.addCalendarYears(this.calendar.activeDate, 1);
  }

  private initializeLanguage(): void {
    const language = localStorage.getItem('language');
    this.dateAdapter.setLocale(language ? language : 'en');
    this.dateAdapter.getFirstDayOfWeek = () => 1;
  }
}
